import _ from 'lodash';
export default class TrackingAbstract {
    constructor($q, $window, $log, Browser, currentUserHelper, institutionHelper, roomHelpersFactory, VideoProviderFactory) {
        this.$q = $q;
        this.$window = $window;
        this.$log = $log;
        this.Browser = Browser;
        this.currentUserHelper = currentUserHelper;
        this.institutionHelper = institutionHelper;
        this.roomHelpersFactory = roomHelpersFactory;
        this.VideoProviderFactory = VideoProviderFactory;
        this.platformData = this.Browser.getPlatformData();
    }
    // ===========================================================================
    // Public methods
    // ===========================================================================
    trackButtonClick(btnProperties) {
        this.track('Button Clicked', {
            button_text: null,
            button_action: null,
            context: null,
            user_type: this.getUserType(),
            session_id: _.get(this.VideoProviderFactory, 'activeProvider.callSession.id', null),
            ...btnProperties,
        }, {});
    }
    // ===========================================================================
    // Protected methods
    // ===========================================================================
    getUserType() {
        const userType = this.currentUserHelper.getUserType();
        return userType !== null ? userType : 'patient';
    }
}
